module.exports = __webpack_public_path__ + "static/media/leaf.1ddbf24f.svg";